













































import { Component } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IActiveMqBrokerConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogForm, FormText },
  validations: {
    brokerName: {
      required
    },
    transportUri: {
      required
    },
    queueName: {
      required
    },
    numConsumers: {
      required
    }
  }
})
export default class ActiveMqBrokerFields extends DialogSection {
  brokerName = "sitewhere";
  transportUri = "";
  queueName = "sitewhere";
  numConsumers = 3;

  /** Reset section content */
  reset(): void {
    this.brokerName = "sitewhere";
    this.transportUri = "";
    this.queueName = "sitewhere";
    this.numConsumers = 3;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IActiveMqBrokerConfiguration): void {
    this.brokerName = input.brokerName || "sitewhere";
    this.transportUri = input.transportUri || "";
    this.queueName = input.queueName || "sitewhere";
    this.numConsumers = input.numConsumers || 3;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      brokerName: this.brokerName,
      transportUri: this.transportUri,
      queueName: this.queueName,
      numConsumers: this.numConsumers
    };
  }
}
